/**
 * Marks that app/plugins/chunk-error-reload.client.ts is tearing the page down after a
 * failed chunk import, so sentry.client.config.ts can drop the errors that follow.
 *
 * Cancelling `vite:preloadError` makes Vite's preload helper swallow the rejection, so
 * the failed `import()` resolves to `undefined` instead. Vue Router then reports the
 * page component as unresolvable ("Couldn't resolve component \"default\" at \"/\"")
 * before `reloadNuxtApp()` has replaced the document — a second name for a chunk error
 * we already recover from, not a routing bug.
 *
 * Backed by `globalThis` so the plugin and the Sentry client config share one flag even
 * if they end up in separate bundles.
 */

const FLAG = '__chunkErrorReloading' as const

declare global {
  var __chunkErrorReloading: boolean | undefined
}

export function markChunkErrorReloading(): void {
  globalThis[FLAG] = true
}

export function isChunkErrorReloading(): boolean {
  return globalThis[FLAG] === true
}
